import type { Sx } from '@dhl-ui/theme'
import { spacing } from '../../theme/spacing'
import { type AlertProps } from './types'

type Props = {
  severity: NonNullable<AlertProps['severity']>
  variant?: AlertProps['variant']
  isRounded: boolean
  isDense: boolean
  isSticky: boolean
}

export const useStyle = ({ severity, variant, isRounded, isDense, isSticky }: Props) => {
  const mainOrDark = severity === 'success' ? 'dark' : 'main'
  const palette = variant === 'filled' ? mainOrDark : 'light'

  const sx: Sx = {
    ...(isSticky ? { position: 'sticky', top: 0 } : {}),
    p: spacing(isDense ? 0 : 1, 2),
    backgroundColor: variant === 'outlined' ? undefined : `${severity}.${palette}`,
    color: variant === 'filled' ? 'pure.light' : `${severity}.dark`,
    borderRadius: ({ misc }) => (isRounded ? misc.borderRadius(2) : 0),
    border: ({ misc }) => (variant === 'outlined' ? misc.borderStyle(`${severity}.main`) : ''),
    borderColor: `${severity}.main`,
  }

  return sx
}
